import {ReactElement} from 'react';

import {TestIdProps} from 'shared/web';

import {GridApi} from './AgGridTypes';

export interface QuickFilterRendererProps extends TestIdProps {
  submitQuickFilter: (query: string) => void;
  cancelQuickFilter: () => void;
  onQuickFilterValueChange: (value: string) => void;
  inputPlaceholder?: string;
  quickFilterValue?: string;
  gridCode: string;
  gridApi?: GridApi;
}

export type QuickFilterRenderer = (props: QuickFilterRendererProps) => ReactElement | null;
